import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Market from "@/pages/Market";
import CreatorProfile from "@/pages/CreatorProfile";
import Auction from "@/pages/Auction";
import NewListing from "@/pages/NewListing";
import Wallet from "@/pages/Wallet";
import Proof from "@/pages/Proof";
import DemoMarc from "@/pages/DemoMarc";
import Outbid from "@/pages/Outbid";
import List from "@/pages/List";
import Rules from "@/pages/Rules";
import About from "@/pages/About";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

const Layout = ({ children }) => (
    <div className="app-shell app-noise flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-1 relative z-[1]">{children}</main>
        <Footer />
    </div>
);

function App() {
    return (
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/market" element={<Market />} />
                    <Route path="/market/new" element={<NewListing />} />
                    <Route path="/c/:handle" element={<CreatorProfile />} />
                    <Route path="/a/:id" element={<Auction />} />
                    <Route path="/wallet" element={<Wallet />} />
                    <Route path="/proof/:id" element={<Proof />} />
                    <Route path="/demo-marc" element={<DemoMarc />} />
                    <Route path="/list" element={<List />} />
                    <Route path="/outbid" element={<Outbid />} />
                    <Route path="/rules" element={<Rules />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                </Routes>
            </Layout>
            <Toaster position="top-center" richColors />
        </BrowserRouter>
    );
}

export default App;
